import "@fontsource-variable/archivo";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ConnectionQueryProvider } from "./components/ConnectionQueryProvider";
import { ConnectionSettingsHost } from "./components/ConnectionSettings";
import "./index.css";
import "./styles/conversation.css";
import { Layout } from "./components/Layout";
import { t, useLocale } from "./lib/i18n";
const Dashboard = React.lazy(() => import("./pages/Dashboard").then(module => ({ default: module.Dashboard })));
const Task = React.lazy(() => import("./pages/Task").then(module => ({ default: module.Task })));
const Run = React.lazy(() => import("./pages/Run").then(module => ({ default: module.Run })));
const Agents = React.lazy(() => import("./pages/Agents").then(module => ({ default: module.Agents })));
const Sessions = React.lazy(() => import("./pages/Sessions").then(module => ({ default: module.Sessions })));
const Jobs = React.lazy(() => import("./pages/Jobs").then(module => ({ default: module.Jobs })));
const Job = React.lazy(() => import("./pages/Job").then(module => ({ default: module.Job })));

function LoadingRoute() {
  useLocale();
  return <div className="conversation-loading" role="status">{t("Loading…")}</div>;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConnectionQueryProvider>
      <BrowserRouter useTransitions={false}>
        <React.Suspense fallback={<LoadingRoute />}>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Navigate to="/sessions" replace />} />
            <Route path="/sessions" element={<Sessions />} />
            <Route path="/agents" element={<Agents />} />
            <Route path="/sessions/:sessionId" element={<Sessions />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/jobs/:jobId" element={<Job />} />
            <Route path="/traces" element={<Dashboard />} />
            <Route path="/tasks/:taskId" element={<Task />} />
            <Route path="/runs/:runId" element={<Run />} />
            <Route path="*" element={<Navigate to="/sessions" replace />} />
          </Route>
        </Routes>
        </React.Suspense>
      </BrowserRouter>
    </ConnectionQueryProvider>
    <ConnectionSettingsHost />
  </React.StrictMode>,
);
